module.exports = __webpack_public_path__ + "media/images/talent/point-01-f6ed52606b8316e58e62a73a9264cbc6.png";